<template>
    <BFormDatepicker v-bind="[$props, $attrs]" v-on="$listeners">
        <template v-slot:button-content>
            <svg class="align-baseline fill-current" width="1.25em" height="1.25em">
                <use xlink:href="#sprite-calendar"></use>
            </svg>
        </template>
        <template v-slot:nav-prev-year>
            <BIconChevronDoubleLeft />
        </template>
        <template v-slot:nav-prev-month>
            <BIconChevronLeft />
        </template>
        <template v-slot:nav-this-month>
            <BIconCircleFill />
        </template>
        <template v-slot:nav-next-month>
            <BIconChevronRight />
        </template>
        <template v-slot:nav-next-year>
            <BIconChevronDoubleRight />
        </template>
    </BFormDatepicker>
</template>

<script>
    import { BFormDatepicker } from 'bootstrap-vue';
    import * as icons from '../icons';

    export default {
        inheritAttrs: false,
        components: {
            BFormDatepicker,
            ...icons,
        },
        props: {
            locale: {
                default: 'fr',
            },
            labelNoDateSelected: {
                default: 'jj/mm/aaaa',
            },
            hideHeader: {
                default: true,
            },
            labelHelp: {
                default: '',
            },
        },
    }
</script>
